import moment, { MomentInput } from "moment-timezone";

// sort first by perks and then by created_at
export const sortByPerksAndCreatedAt = <T extends { perks?: any[], created_at: MomentInput }>(a: T, b: T) =>
    (b.perks?.length ?? 0) - (a.perks?.length ?? 0)
    || moment(a.created_at).diff(b.created_at)
    || 0;
